import React, {useState} from 'react'
import {Collapse, CardBody, Card, CardHeader } from 'reactstrap'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faAngleDown, faAngleUp} from "@fortawesome/pro-regular-svg-icons";
import {array} from "prop-types";

export default function Faq(props) {
    const [collapse, setCollapse] = useState([])
    const [cards, setCards] = useState(
        props.cards
    )
    const [data, setData] = useState({
        collapse : [],
    })

    let cardsArray = []
    for (let i = 0; i < props.cardsLength; i++) {
        cardsArray.push(i+1)
    }

    const toggle = (e) => {
        let index = (e.target.dataset.event) ?? e.currentTarget.dataset.event;

        let getCollapse = data.collapse
        let search = data.collapse.indexOf(`${index}`);

        if(search !== -1 ) {
            getCollapse.splice(search, 1)
        } else {
            getCollapse.push(`${index}`)
        }
        setData({collapse: getCollapse})
    }

    const isOpen = (index) => {
        return data.collapse.includes(`${index}`)
    }

    return (
        <div className="faq">
            {cardsArray.map(index => {
                return (
                    <Card className="faq-card"  key={index}>
                        <CardHeader  className="faq-card-header" onClick={toggle} data-event={index}>
                            <h3 className="faq-card-header-title" data-event={index}>
                                {props.cardsHeader(index)}
                            </h3>
                            <span className="faq-card-header-arrow">
                                {(isOpen(index) === true)
                                    ? <FontAwesomeIcon icon={faAngleUp} data-event={index}/>
                                    : <FontAwesomeIcon icon={faAngleDown}  data-event={index}/>
                                }
                            </span>
                        </CardHeader>
                        <Collapse isOpen={isOpen(index) === true}>
                            <CardBody className="faq-card-body">
                                {props.cardsBody(index)}
                            </CardBody>
                        </Collapse>
                    </Card>
                )
            })}
        </div>
    );
}
